export default "__VITE_ASSET__D34BZ5DU__"